<template>
    <div class="card buildingCard">
        <div class="card-body buildingCard-body" v-bind:data-building-id="buildingProcessedId">
            <slot name="title"></slot>
            <form v-on:submit.prevent>
                <dl class="card-text clearfix buildingCard-list">
                    <dt>Execution Date:</dt>
                    <dd>
                        <div class="input-group date execution_date"
                             data-provide="datepicker"
                             data-date-format="dd/mm/yyyy"
                             data-date-week-start="0"
                             data-date-multidate="false"
                             data-date-calendar-weeks="true"
                             data-date-today-highlight="false">
                            <input type="text" class="form-control bg-white" readonly
                                   v-bind:class="{ 'is-invalid': failedValidation.deadLine }"
                                   v-bind:value="executionDateString">
                            <div class="input-group-addon">
                                <span class="glyphicon glyphicon-th"></span>
                            </div>
                            <div class="invalid-feedback" v-if="msgValidation.deadLine">{{msgValidation.deadLine}}</div>
                        </div>
                    </dd>

                    <dt>Preferred Start Time:</dt>
                    <dd>
                        <select class="form-control" v-model="selected">
                            <option v-for="time in timeRange" v-bind:value="time.value">{{time.text}}</option>
                        </select>
                    </dd>
                </dl>

                <div class="clearfix"></div>

                <button type="button" class="btn btn-link float-left buildingCard-body-btn" v-on:click.prevent="$emit('cancel')">
                    Cancel
                </button>

                <template v-if="scheduleTest !== undefined && scheduleTest.report_type === 'supplementary'
                                && ['locked', 'started'].indexOf(scheduleTest.status) < 0">
                    <RequiresSitePermissions v-bind:required-permissions="['WRITE']" v-bind:site-id="building_id">
                        <button v-if="building_test_id" type="button" class="buildingCard-body-btn btn btn-danger"
                                @click="confirmPopup('Delete Test',building_id,scheduleTest.id, index)">
                            Delete
                        </button>

                        <template slot="fallback">
                            <button v-if="building_test_id" type="button" class="buildingCard-body-btn btn btn-danger">
                                Delete
                            </button>
                        </template>
                    </RequiresSitePermissions>
                </template>


                <button v-if="!building_test_id" type="button" class="btn btn-primary float-right buildingCard-body-btn"
                        @click="add()">
                    Add Schedule Test
                </button>

                <button v-if="building_test_id" type="button" class="btn btn-primary float-right buildingCard-body-btn"
                        @click="update()">
                    Update
                </button>
                <div class="clearfix"></div>
                <div class="card-text" v-if="msgValidation.message">
                    <hr>
                    <div class="alert alert-danger m-0" role="alert">{{msgValidation.message}}</div>
                </div>
            </form>
        </div>
        <template>
            <DeleteTestModalComponent
                    v-if="dataToPassToModal.showModal"
                    @updateDataToCloseParent="$parent.isClicked =false"
                    @delete="deleteBuildingTest()"
                    @close="dataToPassToModal.showModal = false"
                    :confirm="confirm"
            ></DeleteTestModalComponent>
        </template>
    </div>
</template>
<script>
import RequiresSitePermissions from "@/components/RequiresSitePermissions";
import Tools from '@/app-model/tools.js'
import DeleteTestModalComponent from '@/components/modal/DeleteModalComponent'

const tools = new Tools()
  export default {
    props: {
      building_id: Number,
      building_test_id: [Number, String],
      comingScheduleTest: [Object, Array],
      report_type: String,
      dead_line: Number,
      execution_date: Number,
      scheduleTest: Object,
      index: [Number, String]
    },
    data () {
      return {
        dataToPassToModal: {
          id: '',
          index: '',
          showModal: false,
        },
        execution_date_string:'',
        dateSelected: new Date(),
        disabledDatesArray: [],
        selected: 0,
        times: {},
        reportType: '',
        executionDate: '',
        executionDateString:'',
        failedValidation: {
          reportType: false,
          deadLine: false
        },
        msgValidation: {
          reportType: undefined,
          deadLine: undefined,
          message: undefined,
        },
        filedMapping: {
          report_type: 'reportType',
          dead_line: 'deadLine',
          message: 'message',
        },
      }
    },
    components: {
      RequiresSitePermissions,
      DeleteTestModalComponent
    },
    computed: {
      tools: function () {
        return new Tools
      },

      getExecutionDate: function () {
        if (this.scheduleTest === undefined) {
          return
        }
        this.executionDateString = new Date(this.execution_date * 1000).toLocaleDateString('en-AU');
        return tools.formatDate(new Date(this.execution_date * 1000));
      },
      datepicker: function () {
        return jQuery(this.$el).find('[data-provide="datepicker"]')
      },
      buildingProcessedId: function () {
        return this.building_id;
      },
      timeRange: function () {
        let hour = 0
        this.times = []
        for (let tmpHour of [' am', ' pm']) {
          for (let n = 0; n < 12; n++) {
            this.times[hour] = {
              text: (n ? n : 12) + tmpHour,
              value: hour
            }
            hour++
          }
        }

        return this.times
      },
      dateRange: function () {
        let now = new Date;
        let start = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3, 0);
        let end = new Date(start.getFullYear() + 1, start.getMonth(), start.getDate() - 2, 0, -1);

        return {
          start_date: `${start.getDate()}/${start.getMonth() + 1}/${start.getFullYear()}`,
          end_date: `${end.getDate()}/${end.getMonth() + 1}/${end.getFullYear()}`,
          start: start,
          end: end,
        }
      },
    },
    mounted () {
      this.initDatePicker();
    },

    methods: {
      initDatePicker() {
        this.reportType = this.report_type;
        this.selected = this.execution_date ? (new Date(this.execution_date * 1000)).getHours() : 0;
        this.setDate();
        let self = this;
        this.datepicker.on('changeDate', function (e) {
          e.date.setDate(e.date.getDate() + 1);
          e.date.setSeconds(e.date.getSeconds() - 1);
          self.executionDate = e.date.getTime();
          self.executionDateString = e.date.toLocaleDateString('en-AU');
          self.$emit('input', e.format('dd/mm/yy'));
        });

        this.datepicker.datepicker('update', new Date(this.executionDate));
        this.datepicker.datepicker('setStartDate', this.dateRange.start);
        this.datepicker.datepicker('setEndDate', this.dateRange.end);
        this.datepicker.datepicker('setDatesDisabled', this.getDisabledDates());
      },
      setDate () {
        let executionDate = new Date(this.execution_date * 1000);
        this.executionDate = executionDate.getTime();
        this.executionDateString = executionDate.toLocaleDateString('en-AU');
      },
      getDateFromDatePicker: function () {
        return (jQuery(this.$el).find('.execution_date').datepicker('getDate')).getTime()
      },

      getDateRange: function (startDate, endDate) {
        let dates = new Array()

        for (let date = new Date(startDate); date <= new Date(endDate); date.setDate(date.getDate() + 1)) {
          dates.push(tools.formatDateWithFullYear(new Date(date)))
        }

        return dates;
      },
      getDatesForTestWithDeadLine: function (deadLine) {
        let deadLineTimeStamp = deadLine * 1000,
          deadLineDate = (new Date(deadLineTimeStamp)).getDate(),
          thirtyDaysForward = new Date(deadLineTimeStamp).setDate(deadLineDate + 30),
          ninetyDaysBack = new Date(deadLineTimeStamp).setDate(deadLineDate - 89);
        return {deadLineTimeStamp, ninetyDaysBack, thirtyDaysForward};
      },
      getDisabledDates () {
        //1. Add
        let disabledDates = this.getDisabledDatesForAdd();
        if(disabledDates === undefined) {
          disabledDates = this.getDisabledDatesForUpdateSupplementary();
        }
        if(disabledDates === undefined) {
          disabledDates = this.getDisabledDatesForUpdateReruanable();
        }

        //4. done data
        return disabledDates;
      },
      getDisabledDatesForAdd() {
        if (this.building_test_id === undefined) {
          return this.populateDisabledDatesFromComingTests();
        }
      },
      getDisabledDatesForUpdateSupplementary() {
        if (this.building_test_id && this.building_test_id > 0 && this.report_type == 'supplementary') {
          return this.populateDisabledDatesFromComingTests();
        }
      },
      getDisabledDatesForUpdateReruanable() {
        if (this.building_test_id && this.building_test_id > 0 && ['annual', 'six-months'].indexOf(this.report_type) > -1) {
          return this.populateDisabledDatesForRerunAbleTest();
        }
      },
      populateDisabledDatesFromComingTests() {
        let now = new Date();
        let disabledDates = this.getDateRange(now.getTime(), (new Date).setDate(now.getDate() + 4));
        for(let i = 0; i < this.comingScheduleTest.length; i++) {
          let scheduleTest = this.comingScheduleTest[i];
          if (['annual', 'six-months'].indexOf(scheduleTest.report_type) > -1) {
            let {ninetyDaysBack, thirtyDaysForward} = this.getDatesForTestWithDeadLine(scheduleTest.dead_line);
            disabledDates = disabledDates.concat(this.getDateRange(ninetyDaysBack, thirtyDaysForward));
          }
          else if (scheduleTest.report_type == 'supplementary' && scheduleTest.id !== this.building_test_id) {
            let executionDateTimeStamp = scheduleTest.execution_date * 1000,
              executionDate = (new Date(executionDateTimeStamp)).getDate(),
              threeDaysBackward = new Date(executionDateTimeStamp).setDate(executionDate.getDate() - 3),
              threeDaysForward = new Date(executionDateTimeStamp).setDate(executionDate.getDate() + 3),
              suppDates = this.getDateRange(threeDaysBackward, threeDaysForward);
            disabledDates = disabledDates.concat(suppDates);
          }
        }
        return disabledDates;
      },
      populateDisabledDatesForRerunAbleTest: function() {
        // only available 90 days between dead line
        let {
          deadLineTimeStamp,
          ninetyDaysBack
        } = this.getDatesForTestWithDeadLine(this.dead_line);
        let wholeYear = this.getDateRange(
          this.dateRange.start.getTime(),
          this.dateRange.end.getTime()
        );
        let daysToDisableAtAnnualUpdate = this.getDateRange(
          ninetyDaysBack,
          new Date(deadLineTimeStamp).setDate(new Date(deadLineTimeStamp).getDate()-1)
        );
        // exclude days To Disable At Annual Update
        return wholeYear.filter(value => !daysToDisableAtAnnualUpdate.includes(value));
      },
      add () {
        let promise =  this.$store.dispatch(
          'apiResult',
          {
            method: 'post',
            path: `api/user-buildings/${this.buildingProcessedId}/schedule-test`,
            path_template: `/api/user-buildings/{building_id}/schedule-test`,
            building_id: this.buildingProcessedId,
            data: {
              execution_date: Math.round(this.getDateFromDatePicker() / 1000),
              time: this.selected
            },
          });

        return this.processPromise(promise);
      },
      update () {
        let promise =  this.$store.dispatch(
          'apiResult',
          {
            method: 'PATCH',
            path: `api/user-buildings/${this.buildingProcessedId}/schedule-test/${this.building_test_id}`,
            path_template: `/api/user-buildings/{building_id}/schedule-test/{building_test_id}`,
            building_id: this.buildingProcessedId,
            data: {
              execution_date: Math.round(this.getDateFromDatePicker() / 1000),
              time: this.selected
            },
          });

        return this.processPromise(promise);
      },

      confirmPopup: function (action, buildingId, testId, index) {

        this.confirm = {
          action: action,
          title: 'Are you sure to execute: ' + action,
          msg: action + ' will delete this Test',
        }
        this.dataToPassToModal.id = testId
        this.dataToPassToModal.index = index
        this.dataToPassToModal.router = `api/user-buildings/${buildingId}/schedule-test/`
        this.dataToPassToModal.showModal = true
        this.dataToPassToModal.pathTemplate = `/api/user-buildings/{building_id}/schedule-test/{building_test_id}`
        this.dataToPassToModal.buildingId = buildingId
      },

      deleteBuildingTest () {
        let promise = this.$store.dispatch('apiResult', {
          method: 'DELETE',
          path: `api/user-buildings/${this.dataToPassToModal.buildingId}/schedule-test/${this.dataToPassToModal.id}`,
          path_template: `/api/user-buildings/{building_id}/schedule-test/{building_test_id}`,
          building_id: this.dataToPassToModal.buildingId,
        });

        return this.processPromise(promise);
      },

      processPromise : function (promise) {
        promise.then(response => {
          switch (response.status) {
            case 200:
              this.$emit('cancel')
              this.$emit('reFetchTests')
              break
            case 422:
              for (let i in response.data) {
                let field = this.filedMapping[i]
                if (field !== undefined) {
                  this.msgValidation[field] = response.data[i].join(', ')
                }
              }
              break
          }
        });
      }
    }
  }

</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
</style>